import { NgModule } from '@angular/core';
import { ModalComponent } from '@core/components/modal/modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    declarations: [
        ModalComponent,
    ],
    imports: [
        DragDropModule,
        MatToolbarModule,
        MatDialogModule,
        FlexModule,
        MatButtonModule,
        MatIconModule,
        NgIf,
        NgScrollbarModule,
        TranslationModule
    ],
    exports: [
        ModalComponent
    ]
})
export class ModalModule {
}
